import React, { useState } from 'react'
import axios from 'axios';
import { useFormik } from 'formik';
import { toast, ToastContainer } from 'react-toastify';
import { serviceProviderAdd, logOutApi } from '../../Context/api';
import { serviceProviderValidation } from '../../Context/validation';
import { commonMessage, statusCodes } from '../../Constants/generalConfig';
import Spinner from '../Spinner/spinner';
import { useNavigate } from 'react-router-dom';
import NumberInput from '../../Component/PhoneInput/phoneInput';
import { isValidPhoneNumber } from 'react-phone-number-input';

const AddServiceProvider = () => {
    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()
    const exceptThisSymbols = ["e", "E", "+", "-", "."];


    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId, userId: adminData.userId, type: 'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }

    const addServiceProvider = useFormik({
        initialValues: {
            name: '',
            providerName: '',
            mobileNo: '',
            email: '',
        },
        validationSchema: serviceProviderValidation,
        validate: (values) => {
            const errors = {};
            if (values?.mobileNo?.length > 0 && (values?.mobileNo && isValidPhoneNumber(values?.mobileNo))) {
                delete errors.mobileNo
            } else {
                errors.mobileNo = "Please enter a valid mobile number ";
            }
            return errors;
        },
        onSubmit: (values) => {
            const data = {
                name: values.name.trim(),
                providerName: values.providerName.trim(),
                mobileNo: `${values.mobileNo}`,
                email: values.email,
            }
            // console.log(data,'PPPPPPPPPPPPPPPPPP')
            // return
            setSpinner(true)
            axios.post(serviceProviderAdd(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    setSpinner(false)
                    setTimeout(() => {
                        navigate(-1)
                        addServiceProvider.resetForm()
                    }, 1000);
                }
                else if (resp.data.code === statusCodes.tokenExpire) {
                    logOutFun()
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            })
                .catch(() => {
                    toast.error(commonMessage.networkError)
                })

        }

    })

    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Add Provider
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4" onSubmit={addServiceProvider.handleSubmit}>
                        {/* <h5>Basic Details</h5> */}
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Name*</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='name'
                                onChange={addServiceProvider.handleChange}
                                value={addServiceProvider.values.name}
                            />
                            {addServiceProvider.touched.name && addServiceProvider.errors.name ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {addServiceProvider.errors.name}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Provider Name*</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='providerName'
                                onChange={addServiceProvider.handleChange}
                                value={addServiceProvider.values.providerName}
                            />
                            {addServiceProvider.touched.providerName && addServiceProvider.errors.providerName ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {addServiceProvider.errors.providerName}
                                </div>
                            ) : null}
                        </div>
                        <div className='col-md-6'>
                            <label htmlFor="recipient-name" className="col-form-label">Email*</label>
                            <input type="text" className="form-control" id="recipient-name"
                                name='email'
                                value={addServiceProvider.values.email}
                                onChange={addServiceProvider.handleChange}
                            />
                            {addServiceProvider.touched.email && addServiceProvider.errors.email ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {addServiceProvider.errors.email} 
                                </div>
                            ) : null} 
                        </div>
                        <div className='col-md-6'>
                            {/* <label htmlFor="recipient-name" className="col-form-label">Mobile Number*</label>
                            <input type="number" className="form-control"
                                maxLength={10}
                                id="recipient-name"
                                name='mobileNo'
                                onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                                value={addServiceProvider.values.mobileNo}
                                onChange={addServiceProvider.handleChange}

                                onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}
                            /> */}
                            <label htmlFor="recipient-name" className="col-form-label">Mobile Number*</label>
                             <NumberInput
                                width={false}
                                Require={false}
                                Name="mobileNo"
                                HandleChange={addServiceProvider}
                                Value={addServiceProvider.values.mobileNo}
                            />
                            {addServiceProvider.touched.mobileNo && addServiceProvider.errors.mobileNo ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {addServiceProvider.errors.mobileNo}
                                </div>
                            ) : null}
                        </div>
                        <p>* Note : Please fill all the mandatory fields</p>
                        < div>
                            <button type="submit" className="btn btn-primary col-0">Submit</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    )
}

export default AddServiceProvider;
